import React from 'react';

interface BottomDockProps {
  children: React.ReactNode;
  footerRef: React.RefObject<HTMLDivElement | null>;
  expanded: boolean;
}

export function BottomDock({ children, footerRef, expanded }: BottomDockProps) {
  return (
    <div
      className={`bottom-dock fixed left-0 right-0 bottom-0 backdrop-blur-sm border-t border-brand-border ${expanded ? 'px-6 pt-4' : 'px-4 pt-1.5'} shadow-lg z-40`}
      style={{
        backgroundColor: 'var(--color-bg)',
        color: 'var(--color-text)',
        paddingBottom: expanded
          ? 'calc(1rem + var(--app-safe-area-bottom))'
          : 'calc(0.5rem + var(--app-safe-area-bottom))',
      }}
      ref={footerRef}
    >
      {children}
    </div>
  );
}
